import { render } from "./confirm-popup.vue?vue&type=template&id=d65fee4c&ts=true"
import script from "./confirm-popup.vue?vue&type=script&lang=ts"
export * from "./confirm-popup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__